import { Col, PageWrapper, Row } from '@qonsoll/react-design'

import { NewsTipOneStepCreation } from 'domains/NewsTip/components'
import { useTranslations } from '@qonsoll/translation'

const NewsTipWizardPage = (props) => {
  const { t } = useTranslations()
  /* Configuring page header */
  const headingProps = {
    title: t('Welcome') + '!',
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'center'
  }

  return (
    <PageWrapper headingProps={headingProps}>
      <Row noGutters h="center">
        <Col cw={12}>
          <NewsTipOneStepCreation />
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default NewsTipWizardPage
